import React, { useMemo, useState } from "react";
import styled from "styled-components";
import LiveSessionPill from "./LiveSessionPill";

export const LiveSessionsSection = ({
  status,
  sessions,
  transcripts = {},
  snapshotCount = 0,
  classes = [],
  initialExpandedId = null,
  onEndSession,
}) => {
  // One pill open at a time, as with the history cards. A pill whose session
  // ends leaves the map, which closes it with nothing to reset.
  const [expandedId, setExpandedId] = useState(initialExpandedId);

  const classroomNameById = useMemo(() => {
    const map = {};
    for (const c of classes || []) map[c.id] = c.name;
    return map;
  }, [classes]);

  const visibleSessions = useMemo(() => Object.values(sessions || {}), [sessions]);

  if (status === "disabled" || visibleSessions.length === 0) return null;

  return (
    <Section aria-label="Live sessions">
      {visibleSessions.map((s) => (
        <LiveSessionPill
          key={s.session_id}
          session={s}
          classroomName={classroomNameById[s.classroom_id]}
          expanded={expandedId === s.session_id}
          onToggle={() =>
            setExpandedId((id) => (id === s.session_id ? null : s.session_id))
          }
          transcriptLines={transcripts[s.session_id]}
          snapshotCount={snapshotCount}
          onEndSession={onEndSession ? () => onEndSession(s) : undefined}
        />
      ))}
    </Section>
  );
};

export default LiveSessionsSection;

const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
